import React from "react";
import LogoLoaderSVG from "../assets/loader-logo.svg";

const LogoLoader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative flex items-center justify-center w-[120px] h-[120px]">
        {/* Black background inside the spinner */}
        <div className="absolute inset-0 flex items-center justify-center bg-black rounded-full"></div>

        {/* Spinner with transparent top border */}
        <div
          className="absolute inset-0 border-8 border-brandPurple-500 border-t-transparent rounded-full animate-spin"></div>

        {/* Logo */}
        <img
          src={LogoLoaderSVG}
          alt="Glix-Logo"
          className="w-[60px] h-[60px] object-contain z-10 mt-2"
        />
      </div>
    </div>
  );
};

export default LogoLoader;